export const actions = {

  'UI_SET_LANGUAGE': 'ui/setLanguage',
  'UI_GET_SLIDES': 'ui/getSlides',

  'CORE_GET_ORDER_HISTORY': 'core/getOrderHistory',
  'CORE_GET_CONTACTS': 'core/getContacts',

  'MUNDIHUB_GET_COUNTRIES': 'mundihub/getCountries',
  'MUNDIHUB_GET_SERVICES': 'mundihub/getServices',


  'TOPUP_SET_RECIPIENT': 'topup/setRecipient',
  'TOPUP_GET_PRODUCTS': 'topup/getProducts',
  'TOPUP_RESET': 'topup/reset',


  'CART_RESET': 'cart/reset',
  'CART_ADD_ITEM': 'cart/addItem',
  'CART_REMOVE_ITEM': 'cart/removeItem',
  'CART_RESTORE_LAST_SESSION': 'cart/restoreLastSession',


  'ADMIN_LIST_SLIDES': 'admin/listSlides',
  'ADMIN_GET_SLIDE': 'admin/getSlide',
  'ADMIN_UPDATE_SLIDE': 'admin/updateSlide',
  'ADMIN_CREATE_SLIDE': 'admin/createSlide'


};



export const mutations = {

  'UI_SET_LANGUAGE': 'ui/setLanguage',
  'UI_SET_SLIDES': 'ui/setSlides',

  'MUNDIHUB_SET_COUNTRIES': 'mundihub/setCountries',
  'MUNDIHUB_SET_SERVICES': 'mundihub/setServices',


  'TOPUP_SET_RECIPIENT': 'topup/setRecipient',
  'TOPUP_RESET': 'topup/reset',

  'CART_RESET': 'cart/reset',
  'CART_ADD_ITEM': 'cart/addItem',
  'CART_SET_ITEMS': 'cart/addItems',
  'CART_REMOVE_ITEM': 'cart/removeItem',

  'ADMIN_UPDATE_SLIDE': 'admin/updateSlide',


};



// WEBPACK FOOTER //
// ./src/store/constants.js